/**
 * SelectorNode - executes children until one succeeds (logical OR).
 * Returns Success on first child success, Failure if all fail.
 */

import { EngineClass } from '../../../../systems/ClassRegistry.js';
import { BehaviorStatus } from '../../BehaviorNode.js';
import { CompositeNode, type CompositeNodeOptions } from '../CompositeNode.js';

import type { Blackboard } from '../../blackboard/Blackboard.js';
@EngineClass('SelectorNode')
export class SelectorNode extends CompositeNode {
  constructor(options: CompositeNodeOptions = {}) {
    super({
      name: 'Selector',
      ...options
    });
  }

  protected async onExecute(blackboard: Blackboard, deltaTime: number): Promise<BehaviorStatus> {
    // If no children, return failure
    if (this.children.length === 0) {
      return BehaviorStatus.Failure;
    }

    // Execute children until one succeeds
    while (this.currentChildIndex < this.children.length) {
      const currentChild = this.children[this.currentChildIndex];
      const childStatus = await currentChild.execute(blackboard, deltaTime);

      switch (childStatus) {
        case BehaviorStatus.Success:
          // Selector succeeds if any child succeeds
          this.reset();
          return BehaviorStatus.Success;

        case BehaviorStatus.Failure:
          // Move to next child
          this.currentChildIndex++;
          break;

        case BehaviorStatus.Running:
          // Keep running current child
          return BehaviorStatus.Running;
      }
    }

    // All children failed
    this.reset();
    return BehaviorStatus.Failure;
  }
}